import { render, staticRenderFns } from "./high-networth-icon.vue?vue&type=template&id=667c12a1"
import script from "./high-networth-icon.vue?vue&type=script&lang=js"
export * from "./high-networth-icon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports